import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import xml from "csi/xml";

const NewPrintDesignColorForm = declare(Widget, {
	/**
	 * @override
	 * Attach form node to parent product
	 */
	onWriteFormReport(field, writer, formInfo) {
		const { nodeUrl, contextUrl } = formInfo;
		const masterNodeUrl = this.cacheView.get(contextUrl)?.Master || xml.getClientNodeUrl();

		writer.changeNode(nodeUrl).attach(masterNodeUrl, "Colors");
	},
});

export = NewPrintDesignColorForm;